import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from './AuthContext';
import { PostMessageProvider } from './PostMessageContext';
import './App.css';

// Static imports — safe and reliable
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import LeadsPage from './pages/LeadsPage';
import QuotesPage from './pages/QuotesPage';
import BrandingPage from './pages/BrandingPage';
import AccountPage from './pages/AccountPage';
import WidgetsPage from './pages/WidgetsPage';
import IntegrationsPage from './pages/IntegrationsPage';
import ProductsPage from './pages/ProductsPage';
import EnginesPage from './pages/EnginesPage';
import LinkBuilderPage from './pages/LinkBuilderPage';
import EngineUrlsPage from './pages/EngineUrlsPage';
import QuotePage from './pages/QuotePage';
import QuotePageV2 from './pages/QuotePageV2';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import SetupPage from './pages/SetupPage';
import SitemapPage from './pages/SitemapPage';
import WidgetsPageV2 from './pages/WidgetsPageV2';
import QuoteIQV2Page from './pages/QuoteIQV2Page';

function AuthRedirect() {
  const { user, isIframe, iframePending } = useAuth();
  if (iframePending) return null;
  if (isIframe) return <Navigate to="/dashboard" replace />;
  return <Navigate to={user ? '/dashboard' : '/login'} replace />;
}

function LoginGuard() {
  const { user, isIframe, iframePending } = useAuth();
  if (iframePending) return null;
  if (isIframe || user) return <Navigate to="/dashboard" replace />;
  return <LoginPage />;
}

function App() {
  return (
    <PostMessageProvider>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/"                      element={<AuthRedirect />} />
          <Route path="/login"                 element={<LoginGuard />} />
          <Route path="/forgot-password"       element={<ForgotPasswordPage />} />
          <Route path="/setup"                 element={<SetupPage />} />
          <Route path="/dashboard"             element={<DashboardPage />} />
          <Route path="/reports/leads"         element={<LeadsPage />} />
          <Route path="/reports/leads/:type"   element={<LeadsPage />} />
          <Route path="/reports/quotes"        element={<QuotesPage />} />
          <Route path="/quote"                 element={<QuotePage />} />
          <Route path="/quote-v2"              element={<QuotePageV2 />} />
          <Route path="/quoteiq-v2"            element={<QuoteIQV2Page />} />
          <Route path="/settings/branding"     element={<BrandingPage />} />
          <Route path="/settings/quoter"       element={<BrandingPage />} />
          <Route path="/settings/legal"        element={<BrandingPage />} />
          <Route path="/settings/tracking"     element={<BrandingPage />} />
          <Route path="/settings/widgets"      element={<WidgetsPage />} />
          <Route path="/settings/widgets-v2"   element={<WidgetsPageV2 />} />
          <Route path="/settings/integrations" element={<IntegrationsPage />} />
          <Route path="/settings/products"     element={<ProductsPage />} />
          <Route path="/settings/engines"      element={<EnginesPage />} />
          <Route path="/settings/link-builder" element={<LinkBuilderPage />} />
          <Route path="/settings/engine-urls"  element={<EngineUrlsPage />} />
          <Route path="/account"               element={<AccountPage />} />
          <Route path="/sitemap"                element={<SitemapPage />} />
          <Route path="*"                      element={<AuthRedirect />} />
        </Routes>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </AuthProvider>
    </PostMessageProvider>
  );
}

export default App;
